module.exports = __webpack_public_path__ + "assets/img/testqrcode.19722191.png";